'use client';

import { alpha, Box, Typography } from "@mui/material";

interface ErrorBoxProps {
    error?: string;
    size?: 'inline' | 'sm' | 'md' | 'lg';
}

export default function ErrorBox({ error, size = 'md' }: ErrorBoxProps) {

    if (!error) {
        error = "Something went wrong!"
    }

    const paddingSizes = {
        inline: 1,
        sm: 2,
        md: 3,
        lg: 4,
    };

    return (
            <Box
                sx={{
                    padding: paddingSizes[size] || paddingSizes.md,
                    outline: (theme) => `1px solid ${theme.palette.error.main}`,
                    borderRadius: 1,
                    backgroundColor: (theme) => alpha(theme.palette.error.main, .25),
                    color: (theme) => theme.palette.error.contrastText,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    alignSelf: 'center',
                }}
            >
                <Typography variant="body1" noWrap={size === 'inline'}>
                    {error}
                </Typography>
            </Box>
    )
}